$(document).ready(function() {

  // Accounts for orientation change with open menus
  var $desktopNav = $('.desktop-nav.navbar-collapse');
  var $mobileNav = $('.mobile-nav .navbar-collapse');
  var $mobileToggler = $('.navbar-toggler');

  $(window).resize(function() {
    if ($(window).width() < 992) {
      if($('main.home').length) {
        $('.navbar-brand').addClass('show-brand home');

      }
      if($desktopNav.hasClass('show')) {
        $desktopNav.removeClass('show');
        if($mobileToggler.hasClass('collapsed') && !$mobileToggler.hasClass('d-none')) {
          $mobileNav.addClass('show');
          $('.navbar-toggler').removeClass('collapsed');
        }
      }
    }

    if ($(window).width() > 991) {
      if($('main.home').length) {
        if ($('.navbar-brand').hasClass('show-brand home')) {
          $('.navbar-brand').removeClass('show-brand home');
        }
      }
      $('.navbar-toggler').addClass('collapsed');
      if($mobileNav.hasClass('show')) {
        $desktopNav.addClass('show');
        $mobileNav.removeClass('show');
      }
    }
  });

  if ($(window).width() < 992) {
    if($('main.home').length) {
      $('.navbar-brand').addClass('show-brand home');

    } else {
      $('.navbar-toggler').on('click', function() {
        $('.navbar-brand').toggleClass('show-brand');
      });
    }
    $('.navbar-toggler').on('click', function() {
      $('.navbar-dark h1').toggleClass('hidden');
    });
  }

});
